import { useEffect, useState } from "react";
import { Select, message, Form, Row, Col, InputNumber, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdateDO, useDO } from "Components/Topology/queries";

interface DOProps {
  deviceID: string;
  cid: string;
}

const { Option } = Select;

const modes = ["auto", "on", "off", "pulse"];

const DigitalOutput = ({ deviceID }: DOProps) => {
  const { t } = useTranslation();
  const { data: DO_data } = useDO(deviceID);
  const { mutateAsync: updateDOMutation } = useUpdateDO();
  const [form] = Form.useForm();
  const [mode, setMode] = useState("auto");
  const updateDO = (values: any): void => {
    updateDOMutation({ deviceID, mode: values.DO_mode, time: values.DO_Time })
      .then(() => message.success(t("ISMS.Success")))
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  useEffect(() => {
    if (!DO_data) {
      return;
    }
    form.setFieldsValue({
      DO_mode: DO_data.mode || "auto",
      DO_Time: DO_data.time || 30,
    });
  }, [DO_data]);

  return (
    <Form onFinish={updateDO} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <h4 className="ml-2 mt-3">
          {" "}
          {t("ISMS.Current Status")}: {DO_data?.status?.toUpperCase()}
        </h4>

        <Row gutter={24} justify="start" align="middle" className="mt-4">
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name={"DO_mode"}
              label={t("ISMS.DO Mode")}
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={"auto"}
            >
              <Select placeholder={"ON/OFF"} onChange={(value: string) => setMode(value)}>
                {modes.map((mode) => (
                  <Option key={mode} value={mode}>
                    {mode.toUpperCase()}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name={"DO_Time"}
              label={`${t("ISMS.Time")}(ms)`}
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={30}
            >
              <InputNumber style={{ width: "100%" }} placeholder="30" min={0} max={360000} disabled={mode === "auto"} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 7 }}>
            <Form.Item>
              <Button htmlType="submit" type="default">
                {t("ISMS.Submit")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default DigitalOutput;
